// 카카오 지도 SDK 로더 — 필요한 화면에서 처음 한 번만 스크립트를 넣고 kakao.maps 를 돌려준다.
// 키는 빌드 환경변수 REACT_APP_KAKAO_MAP_KEY(없으면 로그인용 JS 키). 카카오 개발자 콘솔에 quinors.com 이 Web 플랫폼으로 등록돼 있어야 뜬다
const KEY = process.env.REACT_APP_KAKAO_MAP_KEY || process.env.REACT_APP_KAKAO_JS_KEY || '15a47e163ff40cf9ac569dc7a94c7b79';
const SRC = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=${KEY}&autoload=false`;
let pending = null;

export default function loadKakaoMaps() {
  if (window.kakao && window.kakao.maps && window.kakao.maps.LatLng) return Promise.resolve(window.kakao.maps);
  if (pending) return pending;
  pending = new Promise((resolve, reject) => {
    const el = document.createElement('script');
    el.src = SRC;
    el.async = true;
    el.onload = () => {
      if (!window.kakao || !window.kakao.maps) { pending = null; reject(new Error('kakao maps missing')); return; }
      window.kakao.maps.load(() => resolve(window.kakao.maps));
    };
    el.onerror = () => { pending = null; el.remove(); reject(new Error('kakao maps load failed')); };
    document.head.appendChild(el);
  });
  return pending;
}
